<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-card-text class="pt-0 pb-1">
          - کلیه سفارشات پس از ثبت در روش‌های زیر به شما اطلاع رسانی خواهد شد.
        </v-card-text>

        <custom-tabs v-model="tabs" :tab-items="tabis" grow>
          <template v-slot:helpinfo="{ tab }">
            <help-info
              v-if="tab && tab.value && tab.text"
              :element-name="`${serviceName}-${componentName}-tab-${tab.value}`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="`${tab.text}`"
            />
          </template>
          <template v-slot:staticItems>
            <v-tab-item>
              <v-row class="pa-2" no-gutters>
                <v-col
                  v-for="(item, index) in computedValue.phones"
                  :key="index"
                  class="pa-2"
                  cols="12"
                  md="6"
                >
                  <div class="rowinfo">
                    <v-text-field
                      v-model="item.number"
                      append-icon="mdi-phone"
                      clear-icon="mdi-close-circle-outline"
                      class="contentinfo"
                      clearable
                      dense
                      hint="لطفا شماره خود را وارد کنید."
                      label="شماره موبایل"
                      outlined
                    >
                      <template v-slot:append-outer>
                        <v-icon @click="addPhone">mdi-plus</v-icon>
                        <v-icon
                          v-if="computedValue.phones.length > 1"
                          @click="computedValue.phones.splice(index, 1)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-text-field>
                    <help-info
                      v-if="index === 0"
                      :element-name="`${serviceName}-${componentName}-item-number`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="شماره موبایل"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>به زودی</v-tab-item>
            <v-tab-item>به زودی</v-tab-item>
          </template>
        </custom-tabs>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "manageOrderNotices",

  props: {
    value: Object,
  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "manage-order-notices",
    tabs: 0,
    tabis: [
      { text: "ارسال پیامک", icon: "message", value: "sms" },
      { text: "ایمیل", icon: "email", value: "email" },
      {
        text: "شبکه‌های اجتماعی",
        icon: "share-variant",
        value: "social_media",
      },
    ],
  }),

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    addPhone() {
      this.computedValue.phones.push({
        number: "",
      });
    },
  },
};
</script>

<style scoped></style>
